import { Button, Paper, Typography } from "@mui/material";

import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import { useState } from "react";

export const ClientGoal = ({ goal }) => {
    const [showMore, setShowMore] = useState(false);

    const isLongText = goal.length > 370;
    const displayedGoal =
        showMore || !isLongText ? goal : goal.substring(0, 250);

    return (
        <Paper sx={{ px: 1, py: 0.5, minHeight: "130px" }} elevation={2}>
            <Typography
                variant="subtitle2"
                sx={{ display: "flex", alignItems: "center" }}
            >
                <TrackChangesIcon color="primary" sx={{ mr: 1 }} /> Campaign
                Goal
            </Typography>

            <Typography sx={{ wordBreak: "break-word" }}>
                {displayedGoal}
                {isLongText && (
                    <Button
                        onClick={() => setShowMore(!showMore)}
                        variant="text"
                        size="small"
                        color="secondary"
                    >
                        {showMore ? "Show Less" : "...Show More"}
                    </Button>
                )}
            </Typography>
        </Paper>
    );
};
